export * from './imageStyle';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const ROUTES = {
  LOGIN: '/login',
  STORIES: '/stories',
  STORY_DETAIL: '/stories/:id',
  EPISODES: '/episodes',
  EPISODE_DETAIL: '/episodes/:id',
  TAGS: '/tags',
  USERS: '/users',
  SOURCE_STORIES: '/source-stories',
  SOURCE_STORY_DETAIL: '/source-stories/:id',
  PROMPT_TEMPLATES: '/prompt-templates',
  IMAGE_STYLES: '/image-styles',
  AUDIO_LIBRARY: '/audio-library',
  AUTO_TASKS: '/auto-tasks',
} as const;

export const STORY_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
} as const;

export const EPISODE_STATUS = {
  DRAFT: 'draft',
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  READY: 'ready',
  PUBLISHED: 'published',
  ERROR: 'error',
  FAILED: 'failed',
} as const;

export const TAG_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  UNISEX: 'unisex',
} as const;

export const VIDEO_JOB_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export const USER_ROLES = {
  SUPER_ADMIN: 'superadmin',
  ADMIN: 'admin',
  EDITOR: 'editor',
} as const;

export const UPLOAD_STATUS = {
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export const PAGE_SIZE = 10;

export const TOKEN_KEY = 'admin_token';
export const USER_KEY = 'admin_user';


